module.exports = function() {
  return new Worker(__webpack_public_path__ + "e05f5500ca783dc15561.worker.js");
};